define('model/OnlineMeetingModel',['require','lib/model/BaseModel'],function (require) {

    var Parent = require('lib/model/BaseModel');

    /**
     * @class OnlineMeetingModel
     */
    return Parent.extend({
        
        urlRoot: '/ext/online-meeting/meeting/id/',

        defaults: {
            id: null
        },
        
        initialize: function (data, options) {
            this._options = options;
			
			Parent.prototype.initialize.apply(this, arguments);
		},
        
        fetch: function (options) {
            var data = _.extend({}, this._options, options && options.data);
            options = _.extend({}, options, {data: data});
            
            return Parent.prototype.fetch.call(this, options);
        },
        
        setOption: function (key, value) {
            this._options[key] = value;
        }

    });

});
